import axios from 'axios'
import LeadsApi from './Leads'

const controller = new window.AbortController()
const axiosHelpers = require('axios-helpers')
let api = axiosHelpers(axios.create({
    baseURL: 'https://api-gateway.hexeko.com/lead/api',
    crossdomain: true,
    headers: {
        'Content-Type': 'application/json'
    },
    timeout: 100000,
    signal: controller.signal,
}))

api.leads = LeadsApi

export default api
